import { boardsApi } from '../../../api';
import type { BoardStateSetter } from '../types';

export const createFetchBoard = (set: BoardStateSetter) => {
  return async (id: string): Promise<void> => {
    set({ isLoadingBoard: true, error: null });
    try {
      const board = await boardsApi.get(id);
      set({ currentBoard: board, isLoadingBoard: false });
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : 'Failed to fetch board',
        isLoadingBoard: false,
      });
    }
  };
};
